<template>
  <v-dialog value="true" persistent width="1200px" class="dialog">
    <participant-details v-if="participantDetails" :raffle-participant="participantDetails" @close="closeParticipantDetails" />
    <v-card>
      <v-container class="d-flex justify-space-between pa-4" fluid>
        <v-card-title class="pa-0">{{ dialogTitle }}</v-card-title>
        <v-container style="width: 300px" class="d-flex justify-end ma-0">
          <mf-search v-model="luckyNumberSearch" hide-details label="Busca" />
        </v-container>
      </v-container>

      <raffle-participants-table
        :search="luckyNumberSearch"
        :empty-table-message="emptyTableMessage"
        :raffle-id="raffle._id"
        @show-details="showParticipantDetails"
      />

      <mf-action-buttons
        class="pa-2"
        :primary-button="{
          text: 'Fechar',
          action: () => $emit('close'),
          isVisible: true,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import RaffleParticipantsTable from './RaffleParticipantsTable.vue'
import ParticipantDetails from './ParticipantDetails.vue'
export default {
  name: 'RaffleParticipantsDialog',
  components: {
    RaffleParticipantsTable,
    ParticipantDetails,
  },
  data: () => ({
    dialogTitle: 'Lista dos participantes',
    luckyNumberSearch: '',
    participantDetails: null,
    emptyTableMessage: 'Ainda não houve nenhum participante no sorteio.',
  }),
  computed: {
    ...mapState({
      raffle: (state) => state.sorteio.raffle,
      raffleParticipants: (state) => state.sorteio.raffleParticipants,
    }),
  },
  watch: {
    luckyNumberSearch() {
      if (!this.luckyNumberSearch) {
        this.emptyTableMessage = 'Ainda não houve nenhum participante no sorteio.'
      } else {
        this.emptyTableMessage = 'Nenhum participante foi encontrado com esse termo.'
      }
    },
  },
  methods: {
    showParticipantDetails(participant) {
      this.participantDetails = participant
    },
    closeParticipantDetails() {
      this.participantDetails = null
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  margin-bottom: 0;
}
.v-dialog {
  transition: all 5s;
}
</style>
